import sample from 'lodash/sample';
import i18next from 'i18next';
var previousRandomSuggestion, randomSuggestion;
export function getRandomSuggestion(suggestions) {
    randomSuggestion = i18next.t(sample(suggestions));
    // reshuffle if needed
    if (previousRandomSuggestion === randomSuggestion) {
        while (randomSuggestion === previousRandomSuggestion) {
            randomSuggestion = i18next.t(sample(suggestions));
        }
    }
    previousRandomSuggestion = randomSuggestion;
    // return with a space after the end of the new phrase
    return "".concat(randomSuggestion, " ");
}
// for use with bidata
export function getCurrentSuggestion() {
    return randomSuggestion;
}
//# sourceMappingURL=util.js.map